module.exports = __webpack_public_path__ + "static/media/glassbotpro-2.4aae2f6c.jpg";